<h2 mat-dialog-title class="text-2xl font-semibold text-primary-600 dark:text-primary-400">{{title | transloco}}</h2>
<mat-dialog-content>
    {{description | transloco}}
    <div 
        *ngIf="type === 'show'" 
        class="relative bg-gray-200 dark:bg-gray-600 border-[1px] border-gray-300 rounded-md p-3 w-full mt-4"
    >
        <p>{{id}}</p>
        <button class="absolute right-2 top-0 bottom-0 translate-y-1" [matTooltip]="'Copy' | transloco" (click)="onCopy()">
            <mat-icon [svgIcon]="'heroicons_outline:clipboard-document'"></mat-icon>
        </button>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="mr-3 flex justify-end">
    @if(type === 'show'){
        <button mat-button mat-dialog-close class="rounded-md bg-primary-500 hover:bg-primary-700 text-white transition duration-150">{{'Close' | transloco}}</button>
    }
    @else{
        <button mat-button mat-dialog-close class="rounded-md hover:bg-red-500 text-red-500 hover:text-white transition duration-150">{{'No' | transloco}}</button>
        <button mat-button mat-dialog-close cdkFocusInitial class="rounded-md bg-primary-500 text-white hover:bg-primary-600 transition duration-150" (click)="onYes()">{{'Yes' | transloco}}</button>
    }
</mat-dialog-actions>
